export class AppSetting {
    // public static API_ENDPOINT = 'http://107.6.27.145:8001/';
    // public static STORAGE_PATH = 'http://107.6.27.145:8001/';
    // public static API_ENDPOINT = 'https://odc.smartrxhub.com/stg/portal_api/public/index.php/';
    // public static STORAGE_PATH = 'https://odc.smartrxhub.com/stg/portal_api/storage/';

    // public static API_ENDPOINT = 'https://odc.smartrxhub.com/panelapistg/';
    /*
     * Production server start
     */
    public static API_ENDPOINT = 'https://odc.smartrxhub.com/panelapi/';
    public static STORAGE_PATH =
        "https://odc.smartrxhub.com/Portal_Api_v4/storage/";

    /*
     * Production server end
     */
    // public static API_ENDPOINT = 'https://odc.smartrxhub.com/panelapistg/';
    // public static STORAGE_PATH = 'https://odc.smartrxhub.com/panelapistg/storage/';
    //public static APPID = 'A1E02634-CA8B-407B-8C9F-47CB8699C42C';

    public static APPID = "6B4443F3-AD85-4CC2-A56C-154E77D81491";
    public static API_TASkS = {
        TASK_USER: "user",
        TASK_COMPANY: "company",
    };
    public static API_ACTION = {
        ACTION_LOGIN: "login",
        ACTION_FORGOT_PASSWORD: "forgotPassword",
        ACTION_RESET_PASSWORD: "resetPassword",
        ACTION_CHECK_RESET_PASSWORD: "checkUserResetPassAuth",
        ACTION_GET_DRP_COMP_FORM_DATA: "getDrpCompFormData",
        ACTION_GET_COMPANY_BY_ID: "getCompanyById",
        ACTION_GET_DRP_KROLL_FACILITY_BY_STORE: "getDrpKrollFacilityByStore",
        ACTION_GET_DRP_USER_FORM_DATA: "getDrpUserFormData",
        ACTION_GET_ALL_PH_USER: "getAllPhUser",
        ACTION_COMPANY_REGISTER: "companyRegister",
        ACTION_GET_ALL_COMPANIES: "getAllCompanies",
        ACTION_ADD_KROLL_HOME_SYNC: "addKrollHomeSync",
        ACTION_ADD_KROLL_BY_STORE: "addKrollHomeByStore",
        ACTION_COMPANIE_UPDATE: "companyUpdate",
        ACTION_GET_COMPANY_ACTIVATION_BY_COMPANY: "getCompanyActKeyByCompany",
        ACTION_ADD_COMPANY_ACTIVATION: "addCompanyActivation",
        ACTION_UPDATE_COMPANY_ACTIVATION: "updateCompanyActivation",
        ACTION_GENERATE_COMPANY_ACTIVATION_KEY: "generateCompanyActivationKey",
        ACTION_GET_COMPANY_ACTIVATION_CODE: "getCompanyActivationByCode",
        ACTION_USER_REGISTER: "userRegister",
        ACTION_USER_UPDATE: "userUpdate",
        ACTION_GET_USER_BY_ID: "getUserById",
        ACTION_GET_ALL_QUEUE: "getAllQueue",
        ACTION_GENERATE_DB_SCRIPT_EMAR: "generateCompanyDbScript",
        ACTION_GENERATE_DB_SCRIPT_RXPAD: "generateCompanyDbScriptRxPad",
        ACTION_GET_ALL_PRINT_QUEUE: "getAllPrintQueue",
        ACTION_GET_ALL_PH_PRINTER: "getAllPrinter",
        ACTION_GET_STORE_DROP_DATA: "getStoreDrpData",
        ACTION_INSERT_PRINTER: "addPrinter",
        ACTION_UPDATE_PRINTER: "updatePrinter",
        ACTION_GET_ALL_PROCEDURE: "getAllProcedure",
        ACTION_DELETE_PROCEDURE: "deleteProcedure",
        ACTION_GET_SERVICE_DRP: "getServiceDrp",
        ACTION_GET_CATEGORY_DRP: "getCategoryDrp",
        ACTION_UPDATE_SERVICE_ITEM_ORD: "updateServiceItemOrd",
        GET_LOCATION_DRP: "getLocationDrp",
        UPDATE_PROCEDURE: "updateProcedure",
        GET_LOCATION_BY_ITEM: "getLocationByItem",
        GET_NEW_APPOINTMENT_COUNT: "getNewAppointmentCount",
        UPDATE_WEB_PUSH_TOKEN: "updateWebPushToken",
        GET_ALL_PROCEDURE_MST: "getAllProcedureMst",
        UPDATE_PROCEDURE_MST: "updateProcedureMst",
        INSERT_PROCEDURE_MST: "insertProcedureMst",
        DELETE_PROCEDURE_MST: "deleteProcedureMst",
        GET_PROCEDURE_MST_BY_CAT: "getProcedureMstByCat",
        UPDATE_PROCEDURE_MST_ORD: "updateProcedureMstOrd",
        GET_LOCATION_BY_PROCEDURE_MST: "getLocationByProcedureMst",
        GET_APPOINTMENT_PROCEDURE_DETAIL: "getAppointmentProcedureDetail",
        DELETE_USER: "deleteUser",
        CREATE_ORDER: "createOrder",
    };
    public static APP_COSTANT = {
        RESPONSE_YES: "yes",
        RESPONSE_NO: "no",
    };
    public static MSG_CONSTANT = {
        MSG_SERVER_RESPONSE_FAIL: "Server response fail",
    };
}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/services/appsetting.ts